import { Action } from 'redux';
import { BasketActionTypes } from '../';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface RemoveCalculateDeliveryCostErrorAction extends Action<BasketActionTypes.REMOVE_ERROR_OF_CALCULATE_DELIVERY_COST> {
}

export const removeCalculateDeliveryCostError: () => RemoveCalculateDeliveryCostErrorAction = () => ({
    type: BasketActionTypes.REMOVE_ERROR_OF_CALCULATE_DELIVERY_COST
});
removeCalculateDeliveryCostError[ACTION_CREATOR_NAME] = 'removeCalculateDeliveryCostError';

export type RemoveCalculateDeliveryCostErrorFunc = (...args: Parameters<typeof removeCalculateDeliveryCostError>) => void;
